import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SportService } from 'app/services/sport/sport.service';
import { pointTypeOfJudge, valueKeys } from 'app/services/sport/judging-rules';

@Injectable({ providedIn: 'root' })
export class CriteriaLabelsService {
  constructor(
    private sportService: SportService,
    private translate: TranslateService
  ) {}

  labels(namespace: string, profileId: string | undefined, judgeCode: string, criteriaCount: number): string[] {
    const translationKeys = this.translationKeys(namespace, profileId, judgeCode);
    return Array.from({ length: criteriaCount }, (_, index) => {
      const translationKey = translationKeys[index];
      const label = translationKey ? this.translate.instant(translationKey) : null;
      return typeof label === 'string' && label !== translationKey ? label : `value ${index + 1}`;
    });
  }

  private translationKeys(namespace: string, profileId: string | undefined, judgeCode: string): string[] {
    if (!profileId) {
      return [];
    }
    const pointType = pointTypeOfJudge(
      this.sportService.getJudgingRulesProfileAttr(profileId, 'judgeGroups'),
      judgeCode
    );
    if (!pointType) {
      return [];
    }
    return valueKeys(this.sportService.getJudgingRulesProfileAttr(profileId, 'pointTypes'), pointType).map(
      (valueKey) => `sport.points.${namespace}.${pointType}.${valueKey}`
    );
  }
}
